import { Tree } from "antd"
import React from "react"
import { YhBox } from "../YhBox"
import { IDictTree } from "./Types"


const DictTree = (props: IDictTree) => {
    const {
        action,
        onSelect,
        selectedKeys,
        treeData,
    } = props


    return (
        <YhBox
            action={action}
            title="字典目录"
            width="500px"
            maxHeight="650px"
        >
            <Tree
                className="p-15"
                treeData={treeData}
                selectedKeys={selectedKeys}
                onSelect={onSelect}
            />
        </YhBox>
    )
}
export default DictTree